import type { User } from '@supabase/supabase-js';

export type UserRole = 'admin' | 'driver' | 'client' | 'fleet_owner';

/** Parse role from JWT claims (app_metadata only — users can edit user_metadata). */
export function parseUserRole(user: User | null | undefined): UserRole | null {
  if (!user) return null;

  const role = user.app_metadata?.role as string | undefined;
  if (role === 'admin' || role === 'driver' || role === 'client' || role === 'fleet_owner') {
    return role;
  }
  return null;
}

export function isAdminRole(role: UserRole | null | undefined): boolean {
  return role === 'admin';
}

export function isFleetOwnerRole(role: UserRole | null | undefined): boolean {
  return role === 'fleet_owner';
}

/** Convert phone to Supabase auth email (matches driver login). */
export function phoneToAuthEmail(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  const normalized = digits.startsWith('0') ? `61${digits.slice(1)}` : digits;
  return `${normalized}@ubus.local`;
}
